import { SnLonLat, SnLonLatLike } from '@lib/geo/helpers';

export abstract class BaseGeometricNavigationService {
  abstract setCenter(coords: SnLonLatLike): void;
  abstract goToCoordinates(coords: SnLonLatLike, zoom?: number): void;
  abstract panTo(coords: SnLonLatLike, options?: Record<string, unknown>): Promise<void>;
  abstract getCenter(): SnLonLat;
}
